import {all, takeEvery, put, call, select} from 'redux-saga/effects';
import {ReducerType} from "../reducer.type";
import { getClientAddressesApi } from "../../services/address.service"
import addressAction from "./actions"
import { ClientWorkspace } from '../client/client.type';
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

const getWorkspace = (state: ReducerType) => state.client.owner.workspace;

export function* GET_ADDRESSES(action: {payload: string, type: string}) {
    try {
        const workspace: ClientWorkspace = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(
          getClientAddressesApi,
          workspace.uuid,
          action.payload
        );
        if (response.data){
            yield put({
                type: addressAction.SET_DATA,
                payload: response.data
            })
        }

    }
    catch (e) { logError("redux/addresses/sagas/GET_ADDRESSES", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(addressAction.GET_DATA, GET_ADDRESSES),
    ])
}
